import React from 'react';
import SocialCard from './SocialCard'; 

const CardGrid = ({ socialLinks }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {socialLinks.map((social, index) => (
        <SocialCard key={index} social={social} />
      ))}
    </div>
  );
};

export default CardGrid;